import { getSegmentReference } from '@component/DriverChat/helpers';
import { FC, useState } from 'react';
import { ChevronDownLineIcon } from '@svg/ChevronDownLineIcon';
import { CircleDotLineIcon } from '@svg/CircleDotLineIcon';
import { MapPinLineIcon } from '@svg/MapPinLineIcon';
import { DriverChatSeed } from '@component/DriverChat/types';
import { getStatusLabel } from '@component/DriverChat/helpers';

type TripCardProps = {
  info: DriverChatSeed;
  statusId: number | null;
  isClosed: boolean;
  dataTestId: string;
};

export const TripCard: FC<TripCardProps> = ({
  info,
  statusId,
  isClosed,
  dataTestId,
}) => {
  // Collapsed until the dispatcher asks for the route details.
  const [isOpen, setIsOpen] = useState(false);
  const hasRoute = !!(info.pickupAddress || info.dropOffAddress);
  const bodyId = `dc-trip-${info.segmentId}`;

  return (
    <div className="dc-trip" data-test-id={`${dataTestId}-trip`}>
      <button
        type="button"
        className="dc-trip__toggle"
        aria-expanded={isOpen}
        aria-controls={bodyId}
        onClick={() => setIsOpen((open) => !open)}
      >
        <span className={`dc-status-pill ${isClosed ? 'is-closed' : ''}`}>
          <i aria-hidden="true" />
          {getStatusLabel(statusId) || 'Status unavailable'}
        </span>
        <span className="dc-trip__segment">
          <span className="dc-mono">{getSegmentReference(info)}</span>
        </span>
        <ChevronDownLineIcon
          width={16}
          height={16}
          strokeWidth={1.75}
          className={`dc-trip__chevron ${isOpen ? '' : 'is-collapsed'}`}
          aria-hidden="true"
        />
      </button>

      {isOpen && hasRoute && (
        <div className="dc-trip__body" id={bodyId}>
          <div className="dc-route">
            <span className="dc-route__icon">
              <CircleDotLineIcon
                width={15}
                height={15}
                strokeWidth={1.75}
                aria-hidden="true"
              />
            </span>
            <span className="dc-route__address">
              <small>Pickup</small>
              {info.pickupAddress || '—'}
            </span>
            <time>{info.pickupTime ?? ''}</time>

            <span className="dc-route__rail" aria-hidden="true" />
            <span />
            <span />

            <span className="dc-route__icon is-destination">
              <MapPinLineIcon
                width={15}
                height={15}
                strokeWidth={1.75}
                aria-hidden="true"
              />
            </span>
            <span className="dc-route__address">
              <small>Drop-off</small>
              {info.dropOffAddress || '—'}
            </span>
            <time>{info.dropOffTime ?? ''}</time>
          </div>
        </div>
      )}
    </div>
  );
};
